import { ReactComponent as InfoFilledIcon } from '@frontend/icons/info-filled.svg';

import Button from '../Button/Button';
import Dialog, { DialogActions, DialogBody, DialogHeader } from '../Dialog';
import Icon from '../Icon/Icon';
import Text from '../Text';
import TextLink from '../TextLink';

import styles from './PartnerDisclosureModal.module.css';

const OPENPAYD_URL = 'https://www.openpayd.com';

export interface PartnerDisclosureModalProps {
  onApprove: () => void;
}

export default function PartnerDisclosureModal({
  onApprove,
}: PartnerDisclosureModalProps): JSX.Element {
  return (
    <Dialog
      className={styles['dialog']}
      disableCloseOnBackdropClick
      disableCloseOnEscapePress
      data-test-id="partner-disclosure-modal"
    >
      <DialogHeader>
        <div className={styles['title']}>
          <span className={styles['label']}>
            <Icon
              className={styles['icon']}
              component={<InfoFilledIcon />}
              color="royal-500"
              size={20}
            />
            Regulatory disclosure
          </span>
        </div>
      </DialogHeader>
      <DialogBody>
        <Text as="p" mt="0" mb="0" align="center" size="small" color="neutral-800">
          All regulated operations accessible through this interface, whether
          involving cryptoassets or fiat funds, are executed exclusively by our
          regulated partner,{' '}
          <TextLink
            className={styles['link']}
            size="inherit"
            href={OPENPAYD_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            OpenPayd
          </TextLink>
          , a fully authorized Electronic Money Institution (EMI) and
          MiCA-regulated Crypto-Asset Service Provider. xMoney acts solely as
          the technology interface and does not provide any regulated service.
        </Text>
      </DialogBody>
      <DialogActions>
        <Button
          size="medium"
          type="button"
          variant="primary"
          onClick={onApprove}
          data-test-id="partner-disclosure-modal-approve"
        >
          I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}
